<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>主体名称</th>
						<td>{{ detailInfo.companyName }}</td>
						<th>主体代码</th>
						<td>{{ detailInfo.companyCode }}</td>
					</tr>
					<tr>
						<th>内容描述</th>
						<td colspan="3">{{ detailInfo.awardIntro }}</td>
					</tr>
					<tr>
						<th>登记部门</th>
						<td>{{ detailInfo.registerDept }}</td>
						<th>登记时间</th>
						<td>{{ detailInfo.registerDate }}</td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { getCompanyBehaviorDetail } from '@/api/qualificationQuery/company'

	// 黑名单记录详情
	export default {
		name: 'BlackListCompanyDetail',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				detailInfo: {},
				isVip: false,
				isSVip: false
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.initDetail()
		},
		methods: {
			initDetail() {
				this.loading = true
				const params = {
					companyBehaviorId: this.id
				}
				getCompanyBehaviorDetail(params)
					.then(res => {
						const { data, code, message } = res
						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.detailInfo = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
